'use strict';

exports.__esModule = true;
exports.toggleVisibility = toggleVisibility;
exports.changePosition = changePosition;
exports.changeSize = changeSize;
exports.changeMonitor = changeMonitor;
var TOGGLE_VISIBILITY = exports.TOGGLE_VISIBILITY = '@@redux-devtools-log-monitor/TOGGLE_VISIBILITY';
function toggleVisibility() {
  return { type: TOGGLE_VISIBILITY };
}

var CHANGE_POSITION = exports.CHANGE_POSITION = '@@redux-devtools-log-monitor/CHANGE_POSITION';
function changePosition() {
  return { type: CHANGE_POSITION };
}

var CHANGE_SIZE = exports.CHANGE_SIZE = '@@redux-devtools-log-monitor/CHANGE_SIZE';
function changeSize(size) {
  return { type: CHANGE_SIZE, size: size };
}

var CHANGE_MONITOR = exports.CHANGE_MONITOR = '@@redux-devtools-log-monitor/CHANGE_MONITOR';
function changeMonitor() {
  return { type: CHANGE_MONITOR };
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-devtools-dock-monitor/lib/actions.js
// module id = 776
// module chunks = 0